import { connect } from 'react-redux';
import { selectConference, selectWatermarkForAttendee } from '@selectors/conference';
import { tokenSelector } from '@selectors/authentication';
import { logError } from '@actions/errorLogger';
import TranscriptView from './TranscriptView.component';

export const mapStateToProps = (state, { watermark }) => ({
  conference: selectConference(state),
  token: tokenSelector(state),
  watermark: selectWatermarkForAttendee(state) || watermark,
});

const mapDispatchToProps = {
  logError,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TranscriptView);



// WEBPACK FOOTER //
// ./components/templates/TranscriptView/TranscriptView.container.js